// extracted by mini-css-extract-plugin
export default {"wrapperTooltip":"Userdata_wrapperTooltip__V55VD","tooltip":"Userdata_tooltip__upcY7"};